<div class="cropper-container tw-w-full tw-h-full tw-relative tw-overflow-hidden tw-flex tw-bg-gray-100 tw-border tw-border-gray-200" #container>
  <canvas
    #canvas
    (mousedown)="onMouseDown($event)"
    (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp()"
    (mouseleave)="onMouseUp()"
    (touchstart)="onMouseDown($event); $event.preventDefault()"
    (touchmove)="onMouseMove($event); $event.preventDefault()"
    (touchend)="onTouchEnd()"
    (touchcancel)="onTouchEnd()"
    class="cropper-canvas tw-cursor-move tw-select-none tw-block !tw-h-full !tw-w-full tw-flex-1"
  ></canvas>
</div>
